import map from 'lodash/map';

export const DEFAULT_PAGE_SIZE = 100;

export const FILE_LIST_MODE_TYPES = {
  MODE_READ: 'MODE_READ',
  MODE_WRITE: 'MODE_WRITE',
  MODE_QUARANTINE_FILES: 'MODE_QUARANTINE_FILES',
  MODE_CRON: 'MODE_CRON',
};

export const FILE_LIST_SORT_CRITERIA = {
  NAME_ASC: {
    label: 'Name Ascending',
    value: 'name&sortorder=asc',
    sortKey: 'name',
    sortOrder: 'asc',
  },
  NAME_DESC: {
    label: 'Name Descending',
    value: 'name&sortorder=desc',
    sortKey: 'name',
    sortOrder: 'desc',
  },
  LAST_INGEST_ASC: {
    label: 'Oldest First',
    value: 'lastIngested&sortorder=asc',
    sortKey: 'lastIngested',
    sortOrder: 'asc',
  },
  LAST_INGEST_DESC: {
    label: 'Most Recent First',
    value: 'lastIngested&sortorder=desc',
    sortKey: 'lastIngested',
    sortOrder: 'desc',
  },
  CRON_ASC: {
    label: 'Oldest First',
    value: 'sortorder=asc',
    sortKey: null,
    sortOrder: 'asc',
  },
  CRON_DESC: {
    label: 'Most Recent First',
    value: 'sortorder=desc',
    sortKey: null,
    sortOrder: 'desc',
  },
  CRON_RUN_ID_ASC: {
    label: 'Oldest First',
    value: 'runId&sortorder=asc',
    sortKey: 'runId',
    sortOrder: 'asc',
  },
  CRON_RUN_ID_DESC: {
    label: 'Most Recent First',
    value: 'runId&sortorder=desc',
    sortKey: 'runId',
    sortOrder: 'desc',
  },
  LAST_WRITE_ASC: {
    label: 'Oldest First',
    value: 'lastWritten&sortorder=asc',
    sortKey: 'lastWritten',
    sortOrder: 'asc',
  },
  LAST_WRITE_DESC: {
    label: 'Most Recent First',
    value: 'lastWritten&sortorder=desc',
    sortKey: 'lastWritten',
    sortOrder: 'desc',
  },
  SIZE_SMALLEST: {
    label: 'Size Smallest',
    value: 'size&sortorder=asc',
    sortKey: 'size',
    sortOrder: 'asc',
  },
  SIZE_LARGEST: {
    label: 'Size Largest',
    value: 'size&sortorder=desc',
    sortKey: 'size',
    sortOrder: 'desc',
  },
  LAST_CREATED_ASC: {
    label: 'Oldest First',
    value: 'created_at&sortorder=asc',
    sortKey: 'lastWritten',
    sortOrder: 'asc',
  },
  LAST_CREATED_DESC: {
    label: 'Most Recent First',
    value: 'created_at&sortorder=desc',
    sortKey: 'lastWritten',
    sortOrder: 'desc',
  },
};

export const FILE_READ_SORT_OPTIONS = map(
  ['NAME_ASC', 'NAME_DESC', 'LAST_INGEST_ASC', 'LAST_INGEST_DESC', 'SIZE_SMALLEST', 'SIZE_LARGEST'],
  (s) => {
    return FILE_LIST_SORT_CRITERIA[s];
  },
);

export const FILE_WRITE_SORT_OPTIONS = map(
  ['NAME_ASC', 'NAME_DESC', 'LAST_WRITE_ASC', 'LAST_WRITE_DESC', 'SIZE_SMALLEST', 'SIZE_LARGEST'],
  (s) => {
    return FILE_LIST_SORT_CRITERIA[s];
  },
);

export const FILE_QUARANTINE_SORT_OPTIONS = map(
  [
    'NAME_ASC',
    'NAME_DESC',
    'LAST_CREATED_ASC',
    'LAST_CREATED_DESC',
    'SIZE_SMALLEST',
    'SIZE_LARGEST',
  ],
  (s) => {
    return FILE_LIST_SORT_CRITERIA[s];
  },
);

export const CRON_READ_SORT_OPTIONS = map(
  ['CRON_RUN_ID_ASC', 'CRON_RUN_ID_DESC', 'SIZE_SMALLEST', 'SIZE_LARGEST'],
  (s) => {
    return FILE_LIST_SORT_CRITERIA[s];
  },
);

export const CRON_WRITE_SORT_GROUP_OPTIONS = map(
  ['CRON_ASC', 'CRON_DESC', 'SIZE_SMALLEST', 'SIZE_LARGEST'],
  (s) => {
    return FILE_LIST_SORT_CRITERIA[s];
  },
);

export const CRON_WRITE_SORT_OPTIONS = map(
  ['CRON_RUN_ID_ASC', 'CRON_RUN_ID_DESC', 'SIZE_SMALLEST', 'SIZE_LARGEST'],
  (s) => {
    return FILE_LIST_SORT_CRITERIA[s];
  },
);

export const FILE_LIST_GROUPBY_CRITERIA = {
  DATA_WRITE_TIME: {
    label: 'Data Write Time',
    value: 'lastWritten',
  },
  DATA_INGESTION_TIME: {
    label: 'Data Ingestion Time',
    value: 'runId',
  },
};

export const CRON_WRITE_GROUPBY_OPTIONS = map(
  ['DATA_WRITE_TIME', 'DATA_INGESTION_TIME'],
  (s) => FILE_LIST_GROUPBY_CRITERIA[s],
);

export const NOTIFICATION_LIST_SORT_CRITERIA = {
  LAST_CREATED_ASC: {
    label: 'Oldest First',
    value: 'created_at&sort_order=ASC',
    sortKey: 'created_at',
    sortOrder: 'ASC',
  },
  LAST_CREATED_DESC: {
    label: 'Most Recent First',
    value: 'created_at&sort_order=DESC',
    sortKey: 'created_at',
    sortOrder: 'DESC',
  },
};

export const NOTIFICATION_LIST_SORT_OPTIONS = map(
  ['LAST_CREATED_ASC', 'LAST_CREATED_DESC'],
  (s) => NOTIFICATION_LIST_SORT_CRITERIA[s],
);
